var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

export let COMMAND_STEP_STATUS = /*#__PURE__*/function (COMMAND_STEP_STATUS) {
  COMMAND_STEP_STATUS["SUCCESS"] = "SUCCESS";
  COMMAND_STEP_STATUS["FAILED"] = "FAILED";
  COMMAND_STEP_STATUS["ERROR"] = "ERROR";
  COMMAND_STEP_STATUS["STARTED"] = "STARTED";
  return COMMAND_STEP_STATUS;
}({});
export let COMMAND_STEP_NAME = /*#__PURE__*/function (COMMAND_STEP_NAME) {
  COMMAND_STEP_NAME["GOOGLE_UPDATE_WEBSITE_URL"] = "GOOGLE_UPDATE_WEBSITE_URL";
  COMMAND_STEP_NAME["GOOGLE_CREATE_AND_LINK_ACCOUNT"] = "GOOGLE_CREATE_AND_LINK_ACCOUNT";
  COMMAND_STEP_NAME["GOOGLE_APPROVE_ACCOUNT_LINK"] = "GOOGLE_APPROVE_ACCOUNT_LINK";
  COMMAND_STEP_NAME["GOOGLE_RETRIEVE_VERIFICATION_TOKEN"] = "GOOGLE_RETRIEVE_VERIFICATION_TOKEN";
  COMMAND_STEP_NAME["GOOGLE_VERIFY_AND_CLAIM_WEBSITE"] = "GOOGLE_VERIFY_AND_CLAIM_WEBSITE";
  COMMAND_STEP_NAME["GOOGLE_SET_MERCHANT_CENTER_ACCOUNT"] = "GOOGLE_SET_MERCHANT_CENTER_ACCOUNT";
  COMMAND_STEP_NAME["SETUP_GOOGLE_LOCAL_INVENTORY_ADS_GMB_LINK"] = "SETUP_GOOGLE_LOCAL_INVENTORY_ADS_GMB_LINK";
  COMMAND_STEP_NAME["SETUP_GOOGLE_LOCAL_INVENTORY_ADS_TARGET_COUNTRY"] = "SETUP_GOOGLE_LOCAL_INVENTORY_ADS_TARGET_COUNTRY";
  COMMAND_STEP_NAME["SETUP_GOOGLE_LOCATION_OBJECT_MAP"] = "SETUP_GOOGLE_LOCATION_OBJECT_MAP";
  COMMAND_STEP_NAME["META_COMMERCE_GET_FBE_INSTALLATION_DETAILS_STEP"] = "META_COMMERCE_GET_FBE_INSTALLATION_DETAILS_STEP";
  COMMAND_STEP_NAME["META_COMMERCE_INSTALL_PIXEL"] = "META_COMMERCE_INSTALL_PIXEL";
  COMMAND_STEP_NAME["META_COMMERCE_DOMAIN_VERIFICATION"] = "META_COMMERCE_DOMAIN_VERIFICATION";
  COMMAND_STEP_NAME["PUBLISH_ALL_LISTINGS"] = "PUBLISH_ALL_LISTINGS";
  COMMAND_STEP_NAME["UPSERT_CATALOG_CUSTOM_ATTRIBUTES"] = "UPSERT_CATALOG_CUSTOM_ATTRIBUTES";
  return COMMAND_STEP_NAME;
}({});
let CommandStep = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('string'), _dec4 = attr('number'), _dec5 = attr('json-or-value'), _dec6 = attr('date'), _dec7 = attr('date'), _dec8 = attr('string'), _dec9 = attr('date'), _dec10 = attr('number'), _dec11 = attr('string'), _dec12 = attr('date'), _dec13 = attr('date'), _dec14 = attr('date'), _dec15 = belongsTo('channels/command'), _dec16 = computed('status'), _dec17 = computed('status'), _dec18 = computed('status'), _class = class CommandStep extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantId", _descriptor, this);
    _initializerDefineProperty(this, "commandId", _descriptor2, this);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "executionOrder", _descriptor4, this);
    _initializerDefineProperty(this, "payload", _descriptor5, this);
    _initializerDefineProperty(this, "startedAt", _descriptor6, this);
    _initializerDefineProperty(this, "processedAt", _descriptor7, this);
    _initializerDefineProperty(this, "status", _descriptor8, this);
    _initializerDefineProperty(this, "lastErroredAt", _descriptor9, this);
    _initializerDefineProperty(this, "attempted", _descriptor10, this);
    _initializerDefineProperty(this, "errorDescription", _descriptor11, this);
    _initializerDefineProperty(this, "createdAt", _descriptor12, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor13, this);
    _initializerDefineProperty(this, "deletedAt", _descriptor14, this);
    _initializerDefineProperty(this, "command", _descriptor15, this);
  }
  get isStatusSuccess() {
    return this.status === COMMAND_STEP_STATUS.SUCCESS;
  }
  get isStatusFailed() {
    return this.status === COMMAND_STEP_STATUS.FAILED;
  }
  get isStatusError() {
    return this.status === COMMAND_STEP_STATUS.ERROR;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "commandId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "executionOrder", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "payload", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "startedAt", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "processedAt", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "status", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "lastErroredAt", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "attempted", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "errorDescription", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "deletedAt", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "command", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isStatusSuccess", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isStatusFailed", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusFailed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isStatusError", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusError"), _class.prototype), _class);
export { CommandStep as default };